module.exports = "<nominas-nomina-documentos-acuserecibo-agregar\r\n    ng-if=\"!$ctrl.data\"\r\n    on-change=\"$ctrl.onChange({$event: $event})\"></nominas-nomina-documentos-acuserecibo-agregar>\r\n<nominas-nomina-documentos-acuserecibo-item\r\n    ng-if=\"$ctrl.data\"\r\n    data=\"$ctrl.data\"\r\n    on-change=\"$ctrl.onChange({$event: $event})\"></nominas-nomina-documentos-acuserecibo-item>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/documentos/acuserecibo/template.html
// module id = 1245
// module chunks = 0